import { CardHeader } from '@/components/atoms/Card';
import type { IconComponent } from '@/components/atoms/SvgIcon/SvgIcon';
import TitleIcon from '@/components/atoms/TitleIcon/TitleIcon';

import './Help.scss';

interface HelpPageUserManualProps {
    linkList: {
        title: string;
        link: string;
    }[];
    linkListWinch?: {
        title: string;
        link: string;
    }[];
    headerText: string;
    headerIcon?: IconComponent;
    description: string;
}

function HelpPageUserManual({
    linkList,
    linkListWinch = [],
    headerText,
    headerIcon,
    description,
}: HelpPageUserManualProps) {
    return (
        <div>
            <CardHeader
                title={headerText}
                level="h2"
                size="card"
                icon={headerIcon && <TitleIcon icon={headerIcon} />}
            />
            <p>{description}</p>
            <ul>
                {linkList.map((list, index) => {
                    return (
                        <li key={index}>
                            <a href={list.link} target="_blank" rel="noreferrer">
                                {list.title}
                            </a>
                        </li>
                    );
                })}
            </ul>
            <ul>
                {linkListWinch.map((list, index) => {
                    return (
                        <li key={index}>
                            <a href={list.link} target="_blank" rel="noreferrer">
                                {list.title}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
export default HelpPageUserManual;
